var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodHeartProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 93.5",
    style: {
      enableBackground: "new 0 0 68 93.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECBD65;}\n\t.st1{fill:#F8A087;}\n\t.st2{fill:#ED4647;}\n\t.st3{fill:#F2E7D9;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 32.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.8,
    cy: 19.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.3,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42,
    cy: 25,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.4,
    cy: 30.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36,
    cy: 24.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34,
    cy: 4.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.8,
    cy: 21.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.2,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.1,
    cy: 27.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.7,
    cy: 20,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.2,
    cy: 25.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.8,
    cy: 11.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.5,
    cy: 9.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,91.6c17.6,0,31.9-14.1,31.9-31.6c0-17.4-14.3-31.6-31.9-31.6S2.1,42.6,2.1,60C2.1,77.4,16.4,91.6,34,91.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.1,49.3c0,0,2.2-6.5,10.9-6.5s14.6,10.8,7.2,20.2s-18,18.6-18,18.6S20.4,69.5,14.7,60.9s1-18.3,9.2-18.3 S34.1,49.3,34.1,49.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "15.2,61.4 22.8,61.4 25.5,54.8 28.5,66.6 30.5,58.7 32.3,64.6 35.9,52.7 39.2,65.3 42,58.1  43.8,62.5 52.4,62.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodHeartProfile);
export default __webpack_public_path__ + "static/media/Blood_Heart_Profile.9ad43154e83abc5b594e33dc4aa8f1a4.svg";
export { ForwardRef as ReactComponent };